module.exports = "pegasus/assets/email1-twitter-icon.png";